import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { InspectionService, MasterViewModel } from "src/proxy";

@Injectable()
export class StatusInspectionStoreService {

    _status$ = new BehaviorSubject<MasterViewModel[]>(null);

    constructor(private inspectionService: InspectionService) {
    }

    loadStatus() {
        return this.inspectionService.getInspectionStatuses();
    }

    getData(): MasterViewModel[] {
        return this._status$.getValue();
    }

    get status() {
        return this._status$.value;
    }

    set status(data: MasterViewModel[]) {
        this._status$.next(data);
    }

    get status$() {
        return this._status$;
    }
}
